import React from "react";

import type { FreelancerStatsSummaryType } from "@js/types/dashboard";
import { formatCurrency } from "@js/utils";

import {
  ReferralsStatsSummaryState,
  ReferralsStatsSummaryStateColumn,
  ReferralsStatsSummaryStateContainer,
} from "../referral-stats";

export type TalentReferralsStatsSummaryProps = {
  summary: FreelancerStatsSummaryType;
};

export const TalentReferralsStatsSummary = ({
  summary,
}: TalentReferralsStatsSummaryProps) => {
  const totalBillings = String(
    summary.total_billed === 0
      ? 0
      : formatCurrency(summary.total_billed, {
          removeDecimal: true,
        }),
  );

  return (
    <ReferralsStatsSummaryStateContainer>
      <ReferralsStatsSummaryStateColumn>
        <ReferralsStatsSummaryState
          label="Total billings"
          value={totalBillings}
          tooltip="Total amount billed from talent you referred to Braintrust.
                      Note that BTRST are rewarded only when invoices are paid."
        />
        <ReferralsStatsSummaryState
          label="Referrals signed up"
          value={summary.referred_count}
          tooltip="Total number of talent who signed up through your referral link.
                      Note that BTRST are rewarded only when referred talent are approved. "
        />
      </ReferralsStatsSummaryStateColumn>
      <ReferralsStatsSummaryStateColumn>
        <ReferralsStatsSummaryState
          label="Referrals approved"
          value={summary.approved_count}
          tooltip="Total number of talent who signed up through your
                      referral link and were approved as Braintrust talent."
        />
        <ReferralsStatsSummaryState
          label="Referrals hired"
          value={summary.hired_count}
          tooltip="Total number of talent who signed up through
                          your referral link and were hired on Braintrust."
        />
      </ReferralsStatsSummaryStateColumn>
    </ReferralsStatsSummaryStateContainer>
  );
};
